export default {"src":"/_next/static/media/logo-myAnalog.1f0fee31.svg","height":17,"width":82,"blurWidth":0,"blurHeight":0};